import { useState } from 'react';
import { LoaderProps } from './types';
import { StyledLoader } from './style';
import { CircularProgress } from '@mui/material';

const Loader = ({ process = true }: LoaderProps) => {
    const [display, setDisplay] = useState(true);

    const onAnimationEnd = () => {
        setDisplay(false);
    };

    return (
        <>
            {display && (
                <StyledLoader
                    className={!process ? 'loaderScaleOut' : ''}
                    onAnimationEnd={onAnimationEnd}
                >
                    <CircularProgress />
                </StyledLoader>
            )}
        </>
    );
};

export default Loader;
